import _regeneratorRuntime from "babel-runtime/regenerator";
import _extends from "babel-runtime/helpers/extends";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import React, { Component, Fragment } from "react";
import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { withFirebaseApp } from "../../util/firebase";
import appService from "../../stores/app";

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

export default compose(connect(function (_ref) {
  var app = _ref.app;
  return app;
}, function (dispatch) {
  return {
    setQuestions: function setQuestions(questions) {
      return dispatch(appService.setQuestions(questions));
    },
    catchError: function catchError(error) {
      return dispatch(appService.setError(error));
    }
  };
}), withFirebaseApp(), lifecycle({
  componentDidMount: function componentDidMount() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _props, firebaseApp, setQuestions, catchError, questionsSnapshot, questions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = _this.props, firebaseApp = _props.firebaseApp, setQuestions = _props.setQuestions, catchError = _props.catchError;

              if (firebaseApp) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return firebaseApp.firestore().collection("questions").orderBy("position").get();

            case 6:
              questionsSnapshot = _context.sent;
              questions = [];

              questionsSnapshot.forEach(function (question) {
                var _question$data = question.data(),
                    answers = _question$data.answers,
                    correct = _question$data.correct,
                    props = _objectWithoutProperties(_question$data, ["answers", "correct"]);

                questions.push(_extends({
                  id: question.id,
                  index: questions.length + 1
                }, props, {
                  answers: answers.map(function (text, index) {
                    return {
                      text: text,
                      isValid: index + 1 === correct
                    };
                  })
                }));
              });
              setQuestions(questions);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              catchError(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 12]]);
    }))();
  }
}))(function App(_ref2) {
  var children = _ref2.children;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Helmet,
      null,
      React.createElement("base", { href: "/" }),
      React.createElement("html", { lang: "fr" }),
      React.createElement("meta", { charSet: "utf-8" }),
      React.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge" }),
      React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" })
    ),
    children
  );
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/App/index.js
// module id = 488
// module chunks = 0